import { createContext } from 'react';

export interface SecurityContextContent {
  accessToken?: string;
  setAccessToken?: (token: string) => void;
  organizationId?: string;
  setOrganizationId?: (id: string) => void;
}

const SecurityContext = createContext<SecurityContextContent>({});

export default SecurityContext;
